"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default() {
  return {
    name: 'join',
    synopsis: 'join [ITEM] [...ITEMS]',
    description: 'Join input by a character',
    options: {
      g: {
        alias: 'glue',
        description: 'Text to join the input with',
        type: 'string',
        default: ' '
      }
    },
    execute: function execute(args, opts) {
      return args.join(opts.g);
    }
  };
};

exports.default = _default;